import React from "react";

export const Dot = React.memo(function Dot() {
  return (
    <span className="fs20 font-isb" aria-hidden>
      ·
    </span>
  );
});
